module.exports = __webpack_public_path__ + "static/media/1.00ac7da1.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Schokwave/Images/1.png
// module id = 692
// module chunks = 0